import type { PIIString } from '@trello/privacy';

import { MemberActivityPage } from 'app/src/components/MembersPages/MemberActivityPage';
import { controllerEvents } from './controllerEvents';
import { renderTopLevelComponent } from './renderTopLevelComponent';
export const memberActivityPageController = async ({
  username,
  section,
  subsection,
}: {
  username: PIIString;
  section?: string | null;
  subsection?: string | null;
}) => {
  controllerEvents.trigger('clearPreviousView');
  controllerEvents.trigger('setViewType', 'MembersView');
  renderTopLevelComponent(<MemberActivityPage username={username} />);
};
